import { render, staticRenderFns } from "./InviraRolesForm.vue?vue&type=template&id=8da13ef0&scoped=true"
import script from "./InviraRolesForm.vue?vue&type=script&lang=js"
export * from "./InviraRolesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da13ef0",
  null
  
)

export default component.exports